import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    CheckInsuranceModalTitle: {
        id: 'Modals.CheckInsuranceModal.Title',
        defaultMessage: 'Check if this doctor is in-network',
    },
    CheckInsuranceModalDescription: {
        id: 'Modals.CheckInsuranceModal.Description',
        defaultMessage: 'Add your insurance and we\'ll check if {providerName} is in-network.',
    },
    CheckInsuranceButton: {
        id: 'Modals.CheckInsuranceModal.CheckInsuranceButton',
        defaultMessage: 'Check my insurance',
    },
});
